


































import { Vue, Component, Watch, Prop } from "@/shared/vuepack";
import VS2 from "vue-script2";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { ChatFunctionalityType } from  "@/shared/types";
import SalesForceChatScript from "./SalesforceChatScript.vue";

Vue.use(VS2);

@Component({
  components: {
    SalesForceChatScript
  }
})
export default class ConsumerChatScript extends Vue {
    @Prop()
    name: string;
    @Prop()
    firstName: string;
    @Prop()
    lastName: string;
    @Prop()
    email: string;
    @Prop()
    phone: string;
    @Prop()
    five9Hashkey: string;
    @Prop()
    salesforceHashkey: string;
    @Prop()
    campaignKey: string;
    @Prop()
    salesforceBase2Url: string;
    @Prop()
    salesforceScrt2Url: string;
    @Prop()
    salesforceBootstrapUrl: string;
    @Prop()
    salesforceOrgId: string;
    @Prop()
    chatDelay: number;
    @Prop()
    chatFunctionalityType: ChatFunctionalityType;

  featureFlagStore = useFeatureFlagStore();

  get useFive9Chatbot () {
    return this.featureFlagStore.flags.hsa5812ConsumerLiveChat && !this.featureFlagStore.flags.hsa8956SalesforceConsumerChat;
  }

  get useSalesforceChatbot () {
    return this.featureFlagStore.flags.hsa8956SalesforceConsumerChat;
  }

  isChatHidden = true;
    mounted () {
      this.showChat();
    }
  showChat ()  {
    setTimeout(() => this.isChatHidden = false, this.chatDelay);
  }
  isSalesforceReadyToRender () {
    return (
      this.firstName &&
      this.lastName &&
      this.email &&
      this.salesforceHashkey &&
      this.chatFunctionalityType &&
      this.salesforceBase2Url &&
      this.salesforceScrt2Url &&
      this.salesforceBootstrapUrl &&
      this.salesforceOrgId
    );
  }
}
